export const enum EventSalesDisplayDisplayEnum {
  table = 'table',
  cards = 'cards',
}

export const enum EventSalesDisplaySearchParamsEnum {
  initialSelectedDateId = 'initialSelectedDateId',
  initialDisplay = 'initialDisplay',
}
